import { Tab, Tabs } from '@material-ui/core';
import { Map } from 'immutable';
import * as React from 'react';
import { connect } from 'react-redux';

import { fetchPersonJobScore } from '../actions';
import { blacklistChecks } from '../extension/blacklist-checks';
import { profileEssentials } from '../extension/profile-essentials';
import { BlacklistCheck, PersonDetails, State } from '../state';
import { ProfileDebugInfoComponent } from './profile-debug-info';

interface ConnectedProps {
    blacklists: Map<string, BlacklistCheck>;
    details: Map<string, PersonDetails>;
}

interface OwnProps {
    personId: string;
    jobId: string;
}

interface ConnectedDispatch {
    fetchPersonJobScore: (personId: string, jobId: string) => void;
}

type PersonExtensionDataProps = ConnectedProps & ConnectedDispatch & OwnProps;

interface PersonExtensionDataState {
    tabValue: number;
}

class PersonExtensionDataComponent extends React.Component<PersonExtensionDataProps, PersonExtensionDataState> {
    constructor(props: PersonExtensionDataProps) {
        super(props);
        this.state = {
            tabValue: 0
        };
        this.ensureDataExists(props);
    }

    ensureDataExists(props: PersonExtensionDataProps) {
        const { personId, jobId, blacklists } = props;
        const key = `${personId}-${jobId}`;
        if (!blacklists.has(key) && jobId) {
            props.fetchPersonJobScore(personId, jobId);
        }
    }

    componentDidUpdate() {
        this.ensureDataExists(this.props);
    }

    handleTabChange = (_: React.ChangeEvent<{}>, tabValue: number) => {
        this.setState({ tabValue });
    };

    render() {
        const { personId, jobId, blacklists, details } = this.props;
        const key = `${personId}-${jobId}`;
        if (!blacklists.has(key) && jobId) return null;

        const { person, profile } = details.get(personId);

        if (!profile) return null;

        const profileTabIcon = (
            <i className="material-icons" style={{ color: '#596D85' }}>
                person
            </i>
        );
        const debugTabIcon = (
            <i className="material-icons" style={{ color: '#596D85' }}>
                bug_report
            </i>
        );
        const blacklistChecksData = jobId ? (
            <div className="profile-section-blacklist-checks">{blacklistChecks(blacklists.get(key))}</div>
        ) : null;

        const { tabValue } = this.state;

        const tabContent =
            tabValue === 0 ? (
                <div className="extension-profile-details">
                    {blacklistChecksData}
                    <div className="profile-section-essentials">{profileEssentials(profile.content)}</div>
                </div>
            ) : (
                <ProfileDebugInfoComponent person={person} profile={profile.content} />
            );

        const content = (
            <div>
                <Tabs
                    value={tabValue}
                    onChange={this.handleTabChange}
                    style={{ backgroundColor: 'white', borderBottom: '1px solid #efefef' }}
                    variant="fullWidth"
                >
                    <Tab icon={profileTabIcon} />
                    <Tab icon={debugTabIcon} />
                </Tabs>
                <div className="profile-score-tab">{tabContent}</div>
            </div>
        );

        return (
            <div className="person-job-score">
                <div className="flat-card">{content}</div>
            </div>
        );
    }
}

const mapStateToProps = (state: State): ConnectedProps => ({
    blacklists: state.blacklists,
    details: state.personsDetails.list
});

const mapDispatchToProps: { [action in keyof ConnectedDispatch]: ConnectedDispatch[action] } = {
    fetchPersonJobScore
};

export const PersonExtensionData = connect<ConnectedProps, ConnectedDispatch, OwnProps>(
    mapStateToProps,
    mapDispatchToProps
)(PersonExtensionDataComponent);
